import { createAction } from '@ngrx/store';

export const succeededToSendEmail = createAction(
  '[Common] Succeeded to send email'
);

export const failedToSendEmail = createAction('[Common] Failed to send email');
